import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { BallChangePolicy } from '../../_shared/data/ball-change-policy';

@Component({
  standalone: false,
    selector: 'app-ball-change-policy',
    templateUrl: './ball-change-policy.component.html',
    styleUrls: ['./ball-change-policy.component.scss'],
})
export class BallChangePolicyComponent {
    ballChangePolicy: { description: string, type?: string, frequency: number[] }[] = BallChangePolicy;

    constructor(
        private modalController: ModalController
    ) { }

    async dismiss(bcp?) {
        (await this.modalController.getTop()).dismiss(bcp);
    }

}
